import React from "react";
import { motion } from "framer-motion";
import * as Icons from "lucide-react";

// Data-driven lucide icon renderer
export const Icon = ({ name, className, ...props }) => {
  const Cmp = Icons[name] || Icons.Sparkles;
  return <Cmp className={className} strokeWidth={1.6} {...props} />;
};

export const EASE = [0.22, 1, 0.36, 1];

// Scroll-reveal fade/slide-up wrapper
export const Reveal = ({ children, delay = 0, y = 24, className, as = "div" }) => {
  const M = motion[as] || motion.div;
  return (
    <M
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, ease: EASE, delay }}
    >
      {children}
    </M>
  );
};

// Small monospace overline label
export const Overline = ({ children, className = "" }) => (
  <span
    className={`inline-block font-mono text-[11px] uppercase tracking-[0.24em] text-ajmus-royal ${className}`}
  >
    {children}
  </span>
);

// Section heading block (left aligned by default)
export const SectionHeading = ({ overline, title, description, align = "left", light = false }) => (
  <div className={align === "center" ? "mx-auto max-w-3xl text-center" : "max-w-3xl"}>
    {overline && <Overline className={light ? "text-white/70" : ""}>{overline}</Overline>}
    <h2
      className={`mt-4 font-heading text-4xl font-extrabold tracking-tight sm:text-5xl ${
        light ? "text-white" : "text-ajmus-ink"
      }`}
    >
      {title}
    </h2>
    {description && (
      <p
        className={`mt-5 text-base leading-relaxed sm:text-lg ${
          light ? "text-white/70" : "text-ajmus-steel"
        }`}
      >
        {description}
      </p>
    )}
  </div>
);

// Masked line-by-line reveal for hero headline
export const MaskLine = ({ children, delay = 0 }) => (
  <span className="line-mask">
    <motion.span
      className="block"
      initial={{ y: "110%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 0.9, ease: EASE, delay }}
    >
      {children}
    </motion.span>
  </span>
);
